'use strict';

function getAdditionalStrapcheckedCount(strapAddStrapSaveBtn) {
    let strapChecked = document.querySelectorAll('[data-is-strap-checked="true"]');
    if (strapChecked && strapChecked != null && strapChecked.length > 0) {
        if (strapAddStrapSaveBtn && strapAddStrapSaveBtn != null) {
            return strapChecked.length;
        }
    } else {
        if (strapAddStrapSaveBtn && strapAddStrapSaveBtn != null) {
            return 0;
        }
    }
}

function markChecked(el, isChecked, inStock) {
    if (isChecked && inStock) {
        $(el).prop('checked', true);
        $(el).attr('data-product-checked', 'true');
    }
}

function unmarkChecked(optName) {
    let checkSelectedSTrap = document.querySelector('[data-additionalstrap-name="' + optName + '"]');

    if (checkSelectedSTrap && checkSelectedSTrap != null) {
        checkSelectedSTrap.dataset.productChecked = 'false';
    }
}

export function additionalStrapSelection() {
    $('body').on('click', '.additionalStrapSelector', function(e) {
        e.preventDefault();
        let additionalProducts = document.querySelectorAll('[data-auth-component="additional-strap-count"]:checked'),
            productIDs = [],
            parentPid = additionalProducts.length > 0 ? $('.pdp-main').data('pid') : null;

        [].forEach.call(additionalProducts, function(currentItem) {
            if (currentItem.dataset.strapInstock === 'true') {
                productIDs.push(currentItem.defaultValue);
            }
        });

        $.ajax({
            url: this.getAttribute('data-url'),
            type: 'get',
            data: {
                products: JSON.stringify(productIDs),
                parentPid: parentPid
            },
            success: function(data) {
                if (data.success) {
                    $('[data-product-personalisation="VASDescAddStrap"]').text(productIDs.length);
                    $('[data-product-personalisation-addstrap="remove"]').removeClass('hidden');
                }
            }
        });
    });

    $(document).ready(function() {
        let strapAddStrapSaveBtn = document.querySelector('[data-product-strap-add-save]');
        if ($('.product-strap-add [data-additionalstrap-name]') && $('.product-strap-add [data-additionalstrap-name]') != null ) {
            $('.product-strap-add [data-additionalstrap-name]').unbind('click').bind('click', function() {
                let isChecked = this.checked;
                let optName = $(this).attr('data-additionalstrap-name'),
                    inStock = $(this).attr('data-strap-instock') === 'true' ? true : false,
                    optNameSelectedLength = 1,
                    strapKey = document.querySelector('[data-id="' + optName + '"]');
                markChecked(this, isChecked, inStock);
                unmarkChecked(optName);

                optNameSelectedLength = $('[data-additionalstrap-name="' + optName + '"]:checked').length;

                if (optNameSelectedLength > 0 && inStock) {
                    $('.' + optName + '-count').html('(' + optNameSelectedLength + ')');
                    strapKey.dataset.isStrapChecked = 'true';
                    $('.' + optName + '-count').removeClass('hidden');
                } else {
                    strapKey.dataset.isStrapChecked = 'false';
                    $('.' + optName + '-count').addClass('hidden');
                }
                strapAddStrapSaveBtn.dataset.countOn = getAdditionalStrapcheckedCount(strapAddStrapSaveBtn);
            });
        }
    });

    $(document).ready(function() {
        if ($('[data-product-personalisation-addstrap="remove"]') && $('[data-product-personalisation-addstrap="remove"]') != null ) {
            $('[data-product-personalisation-addstrap="remove"]').click(function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                let strapChecked = document.querySelectorAll('[data-product-checked="true"]');
                if (strapChecked && strapChecked != null && strapChecked.length > 0) {
                    $('[data-product-checked="true"]').prop('checked', false);
                    $('[data-product-checked="true"]').attr('data-product-checked', 'false');
                }
                $.ajax({
                    url: this.getAttribute('data-url'),
                    type: 'get',
                    success: function(data) {
                        if (data.success) {
                            if (document.querySelector('[data-product-personalisation="VASDescAddStrap"]') != null) {
                                let textNone = document.querySelector('[data-product-personalisation="VASDescAddStrap"]').dataset.messageNone;
                                $('[data-product-personalisation="VASDescAddStrap"]').text(textNone);
                                $('[data-product-personalisation-addstrap="remove"]').addClass('hidden');
                            }
                        }
                    }
                });
            });
        }
    });
}
